/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const markWhatsAppMessagesAsReadDataSchema = z.object({
	messageIds: z.array(z.string()).nullable().optional(),
})

export type MarkWhatsAppMessagesAsReadDataSchema = z.infer<typeof markWhatsAppMessagesAsReadDataSchema>
